import { Navigate } from 'react-router-dom';
import { API_URL } from '../Utils/api';
import { useEffect } from 'react';
import socket from '../Utils/socket';
import axios from 'axios';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');

    useEffect(() => {
        fetch(`${API_URL}/user_data`, { headers: { Authorization: `Bearer${token}` } })
          .then(r => r.json())
          .then(d => {
            localStorage.setItem('userId', d.userId);
            localStorage.setItem('pp', d.userPP);
            localStorage.setItem('username', d.username);
          })
          .catch(() => console.error("Erreur lors de la récupération des données."));
    
        socket.connect();
        socket.on("connect", async () => {
          try { await axios.post(`${API_URL}/socket/getSocketId`, 
            { socketId: socket.id }, { headers: { Authorization: `Bearer${token}` } }); 
        }
          catch { console.error("Socket connection error."); }
        });
        return () => {socket.disconnect(); };
    }, [token]);

    if (!token) {
        // Si pas de token, on redirige vers la page de connexion
        return <Navigate to="/" replace />;
    }

    // Si le token existe, on affiche la page demandée
    return children;
};

export default ProtectedRoute;